module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.done) ? _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "alert alert--error"
  }, [_c('strong', [_vm._v("ลบรายการแล้ว:")]), _vm._v(" "), _c('span', {
    staticClass: "product__desc"
  }, [_vm._v("\n      " + _vm._s(_vm.product.name) + "\n      " + _vm._s(_vm.subSkuSummary) + "\n      (" + _vm._s(_vm.quantity) + " รายการ)\n    ")]), _vm._v(" "), _c('a', {
    staticClass: "edit-action undo-action",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.undo($event)
      }
    }
  }, [_vm._v("ย้อนกลับ")])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-124117d1","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UndoRemove.vue
// module id = 688
// module chunks = 1